import { Avatar, Grid } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { Formaters } from "lib/Formaters";
import { useModalUserProfile } from "providers/UserProfileProvider";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useCardContext } from "../../CardBuilder";

///////////////////////////////////////////////////////////////////////////////////////

export const ModerateReportsCommentAuthor = () => {
    const { pub } = useCardContext();

    const moderateReport = pub.moderateReport!;
    const comment = moderateReport!.comment!;

    const { t } = useTranslation("knowledge");
    const { showUser } = useModalUserProfile();
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <>
            <Grid container justifyContent="center" alignItems="center" spacing={1}>
                <Grid>
                    <Avatar
                        className={AppGlobalClassKeys.clickable}
                        title={comment.author.name}
                        src={comment.author.thumbnailUrl}
                        onClick={
                            () => showUser(
                                comment.author.userId,
                                () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                            )
                        }
                    />
                </Grid>
                <Grid size="grow">
                    <MprcFeedTypography variant="authorPrimary" component="div">
                        <span title={comment.author.name}>{comment.author.name}</span>
                    </MprcFeedTypography>

                    <MprcFeedTypography variant="authorSecondary" component="div">
                        <span>{t("Feed.Card.Common.CommentedText")} {Formaters.relativeTime(comment.createdOn)}</span>
                    </MprcFeedTypography>
                </Grid>
            </Grid>
        </>
    );
};
